import type { ReactElement } from 'react';
import { Alert, Drawer, Skeleton } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';
import { EntityHistoryFeed } from '../../../components/entity-detail/EntityHistoryFeed.js';
import { useEntityActivities } from '../../activity/hooks/useEntityActivities.js';
import { describeActivity } from '../../activity/lib/describeActivity.js';
import type { TaskItem } from '../../tasks/api/tasks.client.js';

export function ContactTaskHistory({
  task,
  onClose,
}: {
  task: TaskItem;
  onClose: () => void;
}): ReactElement {
  const { t } = useTranslation();
  const query = useEntityActivities('task', task.id);
  return (
    <Drawer
      title={t('crm.entity_detail.history')}
      open
      onClose={onClose}
      size={460}
      destroyOnHidden
    >
      <h3>{task.title}</h3>
      {query.isLoading ? (
        <Skeleton active />
      ) : query.error ? (
        <Alert type="error" title={t('crm.entity_detail.load_error')} />
      ) : (
        <EntityHistoryFeed
          items={(query.data ?? []).map((item) => ({
            id: item.id,
            date: item.occurredAt ?? item.createdAt,
            text: describeActivity(item),
          }))}
        />
      )}
    </Drawer>
  );
}
